export const en = {
    "button-save": "Save",
    "checkbox-global-message": "Receive global messages and service news",
    "checkbox-notifications": "Receive service notifications",
    "changes-save-success": "Changes saved",
    "description-receive-global-yandex": "By choosing the subscription \"Global Messages and news of services\", I confirm my consent to receive advertising and\nother marketing messages from YANDEX LLC [Privacy Policy] and [User Agreement].",
    "description-receive-global-yango": "By choosing the subscription \"Global Messages and news of services\", I confirm my consent to receive advertising and\nother marketing messages from YANGO LLC [Privacy Policy] and [User Agreement].",
    "error": "An error has occurred",
    "header-email": "Email Notification Settings",
    "header-settings": "Settings",
    "tab-title-general-settings": "General settings",
    "try-again": "Try again in 10 seconds",
    "sent": "Sent",
    "too-common-error": "This is too vague. Please clarify or confirm.",
} as const;
export const ru = {
    "button-save": "Сохранить",
    "checkbox-global-message": "Получать глобальные сообщения и новости сервисов",
    "checkbox-notifications": "Получать сервисные уведомления",
    "changes-save-success": "Изменения сохранены",
    "description-receive-global-yandex": "Выбирая подписку «Глобальные сообщения и новости сервисов», я подтверждаю свое согласие на получение рекламных и\nиных маркетинговых сообщений от ООО «ЯНДЕКС» [Политики конфиденциальности] и [Пользовательского соглашения].",
    "description-receive-global-yango": "Выбирая подписку «Глобальные сообщения и новости сервисов», я подтверждаю свое согласие на получение рекламных и\nиных маркетинговых сообщений от Yango [Политики конфиденциальности] и [Пользовательского соглашения].",
    "error": "Произошла ошибка",
    "header-email": "Настройки email-уведомлений",
    "header-settings": "Настройки",
    "tab-title-general-settings": "Общие настройки",
    "try-again": "Попробуйте через 10 секунд",
    "sent": "Отправлено",
    "too-common-error": "Слишком общее. Переформулируйте его, либо подтвердите"
} as const;
